import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface QuickBooksInfo {
  correlationIdSearch: string;
  submitTimeSearch: string;
  typeSearch: string;
  statusSearch?: string;
  participantNameSearch: string;
  rowsPerPage: number;
  page: number;
}

const initialState: QuickBooksInfo = {
  correlationIdSearch: "",
  submitTimeSearch: "",
  typeSearch: "All",
  statusSearch: "All",
  participantNameSearch: "All",
  rowsPerPage: 5,
  page: 0,
};

const createQuickBooksLogSlice = createSlice({
  name: "quickBooksLog",
  initialState,
  reducers: {
    setCreateQuickBooksLog: (
      state,
      action: PayloadAction<Partial<QuickBooksInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeQuickBooksLog: () => initialState,
  },
});

export const { setCreateQuickBooksLog, removeQuickBooksLog } =
  createQuickBooksLogSlice.actions;
export default createQuickBooksLogSlice.reducer;
